// extracted by mini-css-extract-plugin
module.exports = {"cardOuter":"_1WCnn","matrixLayout":"_2_KRh","textContainer":"_1zauc","heading":"_2X-GM","text":"_2St2s"};